import { CloseSquare } from "iconsax-react";

export const DeleteConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  itemName,
  isLoading,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/50 z-40" onClick={onClose}></div>

      <div className="fixed min-w-[400px] max-w-[500px] top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 z-50 bg-white rounded-md shadow-lg">
        <div className="px-5 pt-4 flex justify-between items-center rounded-t-md">
          <div className="text-[15px] font-medium select-none">
            <h2>Confirm Deletion</h2>
          </div>
          <button onClick={onClose} disabled={isLoading}>
            <CloseSquare variant="Bold" size={24} />
          </button>
        </div>

        <div className="px-5 py-6">
          <p className="text-[14px] text-gray-700">
            Are you sure you want to delete{" "}
            <span className="font-semibold">"{itemName}"</span>?
          </p>
          <p className="text-[13px] text-gray-500 mt-2">
            This action cannot be undone.
          </p>
        </div>

        <div className="flex justify-end gap-3 px-5 pb-4 rounded-b-md">
          <button
            className="px-4 py-2 text-[14px] font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 text-[14px] font-medium text-white bg-red-600 rounded-md hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading && (
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            )}
            Delete
          </button>
        </div>
      </div>
    </>
  );
};
